import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCog,
  faInfoCircle,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import DataTable from "react-data-table-component";
import { customTableStylesForSummery } from "../../common/customTableStyles";
import {
  getDiscountSettingList,
  getUserPriceList,
  insertDiscountSetting,
} from "../../../api/api";

const countrySelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "42px",
    borderRadius: "0.375rem",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#696cff"
      : state.isFocused
        ? "rgba(105, 108, 255, 0.12)"
        : "#fff",
    color: state.isSelected ? "#fff" : "#4b5563",
  }),
  menu: (base) => ({ ...base, zIndex: 20 }),
};

const parsePgArray = (value) => {
  if (!value) return "";
  if (Array.isArray(value)) return value.join(", ");
  return value
    .replace(/[{}\[\]"]/g, "")
    .split(",")
    .filter(Boolean)
    .join(", ");
};

const DiscountSetting = () => {
  const { id } = useParams();

  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const [discountList, setDiscountList] = useState([]);
  // const [pending, setPending] = useState(true);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  const [formData, setFormData] = useState({
    minpacket: "",
    holdtime: "",
    perdayMinSubmission: "",
    percentage: "",
    senderIds: "",
    deliveryRatio: "",
    failRatio: "",
    status: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const countryOptions = countryList.map((items) => ({
    value: items.country_code,
    label: `${items.country_name} (${items.country_code})`,
  }));

  const getDiscountSetting = () => {
    getDiscountSettingList(id).then((res) => {
      if (res.data.success === true) {
        setDiscountList(res.data.data);
        // setPending(false);
      } 
      else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
        setTimeout(() => {
           seterror({ errarStatus: true});
        },3000)
        // setPending(false);
      }
    });
  };

  useEffect(() => {
    getDiscountSetting();
    // Only the countries this user has a price for on the IPRoute smsc can be
    // chosen (smsc_id === "IPRoute"). The price
    // list has many rows per country, and the code sits in the regex
    // (e.g. "^([\+]?54)" -> 54).
    getUserPriceList(id)
      .then((res) => {
        if (res.data.success !== true) {
          setCountryList([]);
          return;
        }
        const seen = {};
        const countries = [];
        (res.data.data || []).forEach((p) => {
          if (String(p.smsc_id || "").toLowerCase() !== "iproute") return;
          const m = String(p.regex || "").match(/(\d+)/);
          if (!m || seen[m[1]]) return;
          seen[m[1]] = true;
          countries.push({
            country_code: m[1],
            country_name: p.country_name || m[1],
          });
        });
        countries.sort((a, b) => a.country_name.localeCompare(b.country_name));
        setCountryList(countries);
      })
      .catch(() => setCountryList([]));
  }, [id]);

  useEffect(() => {
    if (!id || !discountList.length) return;
    const existing = discountList.find((item) => item.system_id === id);
    if (!existing) return;
    

    setFormData({
      minpacket: existing.minpacket ? String(existing.minpacket) : "",
      holdtime: existing.holdtime ? String(existing.holdtime) : "",
      perdayMinSubmission: existing.perday_min_submission
        ? String(existing.perday_min_submission)
        : "",
      percentage: existing.percentage ? String(existing.percentage) : "",
      senderIds: parsePgArray(existing.sender_json),
      status: String(existing.status),
      deliveryRatio:
        existing.delivery_ratio_percentage !== undefined &&
          existing.delivery_ratio_percentage !== null
          ? String(existing.delivery_ratio_percentage)
          : "",
      failRatio:
        existing.fail_ratio_percentage !== undefined &&
          existing.fail_ratio_percentage !== null
          ? String(existing.fail_ratio_percentage)
          : "",
    });

    const existingCountryCodes = parsePgArray(existing.country_codejson)
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
    setSelectedCountries(
      existingCountryCodes.map((code) => {
        const match = countryList.find(
          (country) => country.country_code === code
        );
        return match
          ? {
            value: match.country_code,
            label: `${match.country_name} (${match.country_code})`,
          }
          : { value: code, label: code };
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountList, id, countryList]);

  const handleMinpacketChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, minpacket: value }));
  };

  const handlePerdayMinSubmissionChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, perdayMinSubmission: value }));
  };

  const handleHoldTimeChange =(e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, holdtime: value }));
  };

  const handleHoldTimeBlur = () => {
    setFormData((prev) => ({
      ...prev,
      holdtime:
        prev.holdtime && parseInt(prev.holdtime, 10) < 5
          ? "5"
          : prev.holdtime,
    }));
  };

  const handlePercentageChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, percentage: value }));
  };

  const handleSenderIdsChange = (e) => {
    setFormData((prev) => ({ ...prev, senderIds: e.target.value }));
  };

  const handleStatusChange = (e) => {
    setFormData((prev) => ({ ...prev, status: e.target.value }));
  };

  const handleDeliveryRatioChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      setFormData((prev) => ({ ...prev, deliveryRatio: "", failRatio: "" }));
      return;
    }
    const value = Math.min(parseInt(raw, 10), 100);
    setFormData((prev) => ({
      ...prev,
      deliveryRatio: String(value),
      failRatio: String(100 - value),
    }));
  };

  const handleFailRatioChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      setFormData((prev) => ({ ...prev, deliveryRatio: "", failRatio: "" }));
      return;
    }
    const value = Math.min(parseInt(raw, 10), 100);
    setFormData((prev) => ({
      ...prev,
      failRatio: String(value),
      deliveryRatio: String(100 - value),
    }));
  };

  const submitHandler = () => {
    seterror({ errarStatus: false });
    setIsSubmitting(true);

    const payload = {
      system_id: id,
      minpacket: parseInt(formData.minpacket || 0, 10),
      holdtime: parseInt(formData.holdtime || 0, 10),
      perday_min_submission: parseInt(formData.perdayMinSubmission || 0, 10),
      percentage: parseInt(formData.percentage || 0, 10),
      delivery_ratio_percentage: parseInt(formData.deliveryRatio || 0, 10),
      fail_ratio_percentage: parseInt(formData.failRatio || 0, 10),
      status: parseInt(formData.status),
      sender_json: formData.senderIds
        .split(",")
        .map((senderId) => senderId.trim())
        .filter(Boolean),
      country_codejson: selectedCountries.map((option) =>
        String(option.value)
      ),
    };

    insertDiscountSetting(payload).then((res) => {
      setIsSubmitting(false);
      if (res.data.success === true) {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-success",
        });
        setTimeout(() => {
          seterror({
            errarStatus: false
          })
        },5000)
        getDiscountSetting();
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
      }
    });
  };

  const columns = [
    {
      name: "System ID",
      selector: (row) => row.system_id,
      sortable: true,
    },
    {
      name: "Min Count",
      selector: (row) => row.minpacket,
      sortable: true,
    },
    {
      name: "Hold Time",
      selector: (row) => row.holdtime,
      sortable: true,
    },
    {
      name: "Percentage",
      selector: (row) => row.percentage,
      sortable: true,
    },
    {
      name: "Delivery Ratio %",
      selector: (row) => row.delivery_ratio_percentage,
      sortable: true,
    },
    {
      name: "Fail Ratio %",
      selector: (row) => row.fail_ratio_percentage,
      sortable: true,
    },
    {
      name: "Sender IDs",
      selector: (row) => parsePgArray(row.sender_json),
      wrap: true,
    },
    {
      name: "Country Codes",
      selector: (row) => parsePgArray(row.country_codejson),
      wrap: true,
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                </div>
              ) : null}

              <style>{`
                .ds-card{background:#fff;border:0;border-radius:14px;box-shadow:0 2px 14px rgba(20,30,70,.07);overflow:hidden}
                .ds-head{display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;padding:22px 30px;background:linear-gradient(90deg,#f6f7fd,#fff);border-bottom:1px solid #eceef6}
                .ds-head-l{display:flex;align-items:center;gap:16px}
                .ds-ico{width:58px;height:58px;border-radius:50%;background:#e9eaff;color:#4a4de6;display:flex;align-items:center;justify-content:center;font-size:1.4rem;flex:0 0 auto}
                .ds-title{font-size:1.35rem;font-weight:700;color:#0f1f3d;margin:0;line-height:1.2}
                .ds-sub{color:#5b6786;font-size:.92rem;margin:2px 0 0}
                .ds-back{border:1px solid #4a4de6;color:#4a4de6;background:#fff;border-radius:8px;padding:9px 22px;font-weight:600;text-decoration:none!important;white-space:nowrap}
                .ds-back:hover{background:#f0f0ff;color:#4a4de6}
                .ds-body{padding:30px}
                .ds-label{display:block;font-size:.78rem;font-weight:700;letter-spacing:.03em;text-transform:uppercase;color:#2a3752;margin-bottom:10px}
                .ds-req{color:#ff3e3e;margin-left:6px}
                .ds-i{color:#2d8cf0;margin-left:6px}
                .ds-body .form-control{height:48px;border:1px solid #dfe3ee;border-radius:8px;color:#0f1f3d;background:#fff}
                .ds-body .form-control:disabled{background:#eceef3;color:#2a3752}
                .ds-body .form-control::placeholder{color:#a3acc0}
                .ds-group{background:#f4f7fe;border:1px solid #e1e8f7;border-radius:10px;padding:18px 20px;height:100%}
                .ds-note{display:flex;align-items:center;gap:8px;color:#1f7ae0;font-size:.85rem;margin-top:12px}
                .ds-note-pill{background:#e6f0fd;border-radius:8px;padding:10px 14px}
                .ds-save{background:#4a4de6;border:0;color:#fff;border-radius:10px;padding:13px 30px;font-weight:700;box-shadow:0 6px 16px rgba(74,77,230,.35)}
                .ds-save:hover{background:#3f42d4;color:#fff}
                .ds-save:disabled{opacity:.7}
                @media (max-width:575.98px){.ds-head{padding:16px}.ds-body{padding:18px 16px}.ds-save{width:100%}}
              `}</style>

              <div className="ds-card mb-4">
                <div className="ds-head">
                  <div className="ds-head-l">
                    <div className="ds-ico">
                      <FontAwesomeIcon icon={faCog} />
                    </div>
                    <div>
                      <h4 className="ds-title">Add Discount Setting</h4>
                      <p className="ds-sub">
                        Configure discount settings for the selected user and country.
                      </p>
                    </div>
                  </div>
                  <Link to="/admin/user-list" className="ds-back">
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                    Go Back
                  </Link>
                </div>

                <div className="ds-body">
                  <div className="row gy-4">
                    <div className="col-lg-3 col-md-6">
                      <label className="ds-label">
                        Username<span className="ds-req">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={id}
                        disabled
                      />
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <label className="ds-label">
                        Daily Minimum Submissions
                        <FontAwesomeIcon icon={faInfoCircle} className="ds-i" />
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter daily minimum submissions"
                        value={formData.perdayMinSubmission}
                        onChange={handlePerdayMinSubmissionChange}
                      />
                    </div>

                    <div className="col-lg-5 col-12">
                      <div className="ds-group">
                        <div className="row gy-3">
                          <div className="col-sm-5">
                            <label className="ds-label">
                              Minimum Count<span className="ds-req">*</span>
                            </label>
                            <input
                              type="text"
                              inputMode="numeric"
                              className="form-control"
                              placeholder="Enter minimum count"
                              value={formData.minpacket}
                              onChange={handleMinpacketChange}
                            />
                          </div>
                          <div className="col-sm-7">
                            <label className="ds-label">
                              Hold Time (in sec)<span className="ds-req">*</span>
                            </label>
                            <input
                              type="text"
                              inputMode="numeric"
                              className="form-control"
                              placeholder="Minimum 5"
                              value={formData.holdtime}
                              onChange={handleHoldTimeChange}
                              onBlur={handleHoldTimeBlur}
                            />
                          </div>
                        </div>
                        <div className="ds-note ds-note-pill">
                          <FontAwesomeIcon icon={faInfoCircle} />
                          Hold time cannot be less than 5 sec.
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-5 col-md-6">
                      <label className="ds-label">
                        Percentage<span className="ds-req">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter percentage"
                        value={formData.percentage}
                        onChange={handlePercentageChange}
                      />
                    </div>

                    <div className="col-lg-7 col-md-6">
                      <label className="ds-label">
                        Country<span className="ds-req">*</span>
                      </label>
                      <Select
                        isMulti
                        isSearchable
                        closeMenuOnSelect={false}
                        options={countryOptions}
                        value={selectedCountries}
                        onChange={(selected) =>
                          setSelectedCountries(selected || [])
                        }
                        placeholder="Select countries"
                        noOptionsMessage={() => "No IPRoute countries for this user"}
                        styles={countrySelectStyles}
                        classNamePrefix="country-select"
                      />
                    </div>

                    <div className="col-lg-7 col-md-6">
                      <label className="ds-label">Sender ID</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Example : 1234, 5678, 9810"
                        value={formData.senderIds}
                        onChange={handleSenderIdsChange}
                      />
                      <div className="ds-note">
                        <FontAwesomeIcon icon={faInfoCircle} />
                        Enter multiple sender IDs separated by commas.
                      </div>
                    </div>

                    <div className="col-lg-5 col-md-6">
                      <label className="ds-label">
                        Delivery Percentage Ratio<span className="ds-req">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter Delivery Percentage Ratio"
                        value={formData.deliveryRatio}
                        onChange={handleDeliveryRatioChange}
                      />
                    </div>

                    <div className="col-lg-5 col-md-6">
                      <label className="ds-label">
                        Failed Percentage Ratio<span className="ds-req">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter Failed Percentage Ratio"
                        value={formData.failRatio}
                        onChange={handleFailRatioChange}
                      />
                      <div className="ds-note">
                        <FontAwesomeIcon icon={faInfoCircle} />
                        Delivery and Failed ratio always add up to 100.
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <label className="ds-label">
                        Status<span className="ds-req">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={formData.status}
                        onChange={handleStatusChange}
                      >
                        <option value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="button"
                        onClick={submitHandler}
                        disabled={isSubmitting}
                        className="ds-save"
                      >
                        <FontAwesomeIcon icon={faSave} className="me-2" />
                        {isSubmitting
                          ? discountList.length > 0
                            ? "Updating..."
                            : "Saving..."
                          : discountList.length > 0
                            ? "Update"
                            : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="card pb-5">
                <h5 className="card-header">Discount Setting</h5>
                <DataTable
                  pagination
                  handleSort
                  columns={columns}
                  data={discountList}
                  progressPending={pending}
                  customStyles={customTableStylesForSummery}
                  noDataComponent="No Discount Setting Found"
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountSetting;
